import { Injectable, Injector } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class ConfirmService {
  constructor(private injector: Injector) {}

  get modalService() {
    return this.injector.get(NzModalService);
  }
  confirmDelete() {
    return new Promise(resolve => {
      this.modalService.confirm({
        nzTitle: 'Confirmation',
        nzContent: 'Are you sure you want to delete the selected record(s)?',
        nzClassName: 'modal-btn',
        nzOnOk: () => resolve(true),
        nzOkDanger: true,
        nzOkText: 'Confirm Delete'
      });
    });
  }
}
